import { isNil } from "@mcwd/typescript-type-guards";
import type { ExpandType, Nil } from "@mcwd/typescript-type-guards";
import type { DocumentResource } from "../widgetDataTs.js";
import type { LinkDownloadType } from "./LinkDownloadType.js";
import type { TagManagerEvent } from "./TagManager/Wrapper/TagManagerWrapper.js";

export type DownloadEventCta = {
  ctaText: string,
  /** The type of link click */
  ctaType: LinkDownloadType
};

export type DownloadEventAsset = {
  assetId: string,
  assetTitle: string,
  assetType: string
}

interface _SendDownloadEventArgs extends DownloadEventCta, DownloadEventAsset { }

export type SendDownloadEventArgs = ExpandType<_SendDownloadEventArgs>;

interface _SendDownloadEventDocumentResourceArgs extends DownloadEventCta {
  asset: DocumentResource
}
export type SendDownloadEventDocumentResourceArgs = ExpandType<_SendDownloadEventDocumentResourceArgs>;

interface DownloadEventObj extends TagManagerEvent {
  event: "download";
  ctaText: string | Nil; // data-download-cta-text
  ctaType: LinkDownloadType; // data-download-cta-type
  assetId: string;
  assetType: string;
  assetTitle: string;
}

export function sendDownloadEvent(sendDownloadEventArgs: SendDownloadEventDocumentResourceArgs): void;
export function sendDownloadEvent(sendDownloadEventArgs: SendDownloadEventArgs): void;
export function sendDownloadEvent(sendDownloadEventArgs: SendDownloadEventDocumentResourceArgs | SendDownloadEventArgs): void {
  const { ctaText, ctaType } = sendDownloadEventArgs;
  const { asset } = ("asset" in sendDownloadEventArgs) ? sendDownloadEventArgs : { asset: null };
  const { assetId, assetType, assetTitle } = isNil(asset)
    ? sendDownloadEventArgs as SendDownloadEventArgs
    : { assetId: asset.legacyId, assetType: asset.docType, assetTitle: asset.title };

  window.McTagManager.sendEvent({
    event: "download",
    ctaText, // data-download-cta-text
    ctaType, // data-download-cta-type
    assetId,
    assetType,
    assetTitle
  } satisfies DownloadEventObj);
}